import { AbstractControl, Validators } from "@angular/forms";
import { FieldEnum, IFormField, SubFieldEnum } from "../../shared/models/form-field";
import { of } from "rxjs";
import { TodayDateValidator } from "../../shared/services/custom-app-validators.service";

const ONLY_NUMBER_PATTERN = /^[0-9]\d*$/;
const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
const FLOAT_NUMBER_PATTERN = /^[0-9]+(\.[0-9]{1,11})?$/;

export const CREATE_PO_FORMFIELDS: Array<IFormField> = [
  
    {
        fieldName: "pr_number",
        displayName: "PR Number",
        defaultValue: null,
        labelName: "PR Number",
        placeholder: "PR Number",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,        
        required: true,
    },
    {
        fieldName: "material",
        displayName: "Material/Service",
        defaultValue: null,
        labelName: "Material/Service",
        placeholder: "Material/Service",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
    },
    {
        fieldName : "document_type",
        displayName : "Document Type",
        defaultValue : "",
        labelName : "Document Type",
        placeholder : "Document Type",
        validators: [Validators.required],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        required: true,
        isAutoComplete: false,
        hasDescription:true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "CONDITION_TYPE",
            bindValue : "CONDITION_TEXT",
            dataFields : []
        }
    },   
    {
        fieldName: "material_group",
        displayName: "ESN Number",
        defaultValue: null,
        labelName: "ESN Number",
        placeholder: "ESN Number",
        validators: [Validators.required],//[Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName: "item_category",
        displayName: "Item Category",
        defaultValue: null,
        labelName: "Item Category",
        placeholder: "Item Category",
        validators: [Validators.required],//[Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },

    {
        fieldName: "conf_ctrl",
        displayName: "confirmation control",
        defaultValue: null,
        labelName: "confirmation control",
        placeholder: "confirmation control",
        validators: null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        isAutoComplete: false,
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "conf_ctrl",
            bindValue : "conf_ctrl",
            dataFields : []
        },
        hasDescription: true,
        required:true
    },
    
    
    {
        fieldName : "packing_code",
        displayName : "Packing Code",
        defaultValue : "",
        labelName : "Packing Code",
        placeholder : "Packing Code",
        validators: null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        isAutoComplete: false,
        hasDescription:true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "packing_code",
            bindValue : "packing_code",
            dataFields : []
        },
    },
    {
        fieldName: "account_assignment_category",
        displayName: "Account Assignment Category",
        defaultValue: null,
        labelName: "Account Assignment Category",
        placeholder: "Account Assignment Category",
        validators: [],//[Validators.required, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{1,1}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "acc_assignment_value",
        displayName: "Account assignment category value",
        defaultValue: null,
        labelName: "Account assignment category value",
        placeholder: "Account assignment category value",
        validators: [] ,//[Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "cost_center",
        displayName: "Cost Center",
        defaultValue: null,
        labelName: "Cost Center",
        placeholder: "Cost Center",
        validators: [] ,//[Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
     {
        fieldName: "po_quantity",
        displayName: "Qty",
        defaultValue: 0,
        labelName: "Qty",
        placeholder: "Qty",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
        required: true
    }, 
    {
        fieldName: "ordering_unit",
        displayName: "Ordering Unit",
        defaultValue: null,
        labelName: "Ordering Unit",
        placeholder: "Ordering Unit",
        validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName: "delivery_date",
        displayName: "Delivery Date",
        defaultValue: null,
        labelName: "Delivery Date",
        placeholder: "Delivery Date",
        validators: [Validators.required,TodayDateValidator()],//yyyy-mm-dd
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,        
    },
    {
        fieldName: "UoM",
        displayName: "UoM",
        defaultValue: null,
        labelName: "UoM",
        placeholder: "UoM",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
        required: true
    },
    {
        fieldName: "material_group",
        displayName: "Material Group",
        defaultValue: null,
        labelName: "Material Group",
        placeholder: "Material Group",
        validators: [Validators.required],//[Validators.required, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,9}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    }, 
    {
        fieldName: "plant",
        displayName: "Plant",
        defaultValue: null,
        labelName: "Plant",
        placeholder: "Plant",
        validators: [Validators.required],// [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,4}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName: "storage_location",
        displayName: "Storage Location",
        defaultValue: null,
        labelName: "Storage Location",
        placeholder: "Storage Location",
        validators: [],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "storage_location",
            bindValue : "storage_location",
            dataFields : []
        },
        hasDescription:true,
    },
    {
        fieldName: "return_item_check",
        displayName: "Return Item Check",
        defaultValue: null,
        labelName: "Return Item Check",
        placeholder: "Return Item Check",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,1}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "free_items",
        displayName: "Free Items",
        defaultValue: null,
        labelName: "Free Items",
        placeholder: "Free Items",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,1}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
   
    {
        fieldName: "currency",
        displayName: "Currency",
        defaultValue: null,
        labelName: "Currency",
        placeholder: "Currency",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
    },
    {
        fieldName: "cond_type_1",
        displayName: "Cond Type 1",
        defaultValue: null,
        labelName: "Cond Type 1",
        placeholder: "Cond Type 1",
        validators: [],
        fieldType : FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        hasDescription:true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "cond_type_1",
            bindValue : "cond_type_1",
            dataFields : []
        }
    },
    {
        fieldName: "cond_value_1",
        displayName: "Cond Value 1",
        defaultValue: null,
        labelName: "Cond Value 1",
        placeholder: "Cond Value 1",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,28}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "cond_type_2",
        displayName: "Cond Type 2",
        defaultValue: null,
        labelName: "Cond Type 2",
        placeholder: "Cond Type 2",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,4}$/)],
        fieldType : FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        hasDescription:true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "cond_type_2",
            bindValue : "cond_type_2",
            dataFields : []
        }
    },
    {
        fieldName: "cond_value_2",
        displayName: "Cond Value 2",
        defaultValue: null,
        labelName: "Cond Value 2",
        placeholder: "Cond Value 2",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,28}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "cond_type_3",
        displayName: "Cond Type 3",
        defaultValue: null,
        labelName: "Cond Type 3",
        placeholder: "Cond Type 3",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,4}$/)],
        fieldType : FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        hasDescription:true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "cond_type_3",
            bindValue : "cond_type_3",
            dataFields : []
        }
    },
    {
        fieldName: "cond_value_3",
        displayName: "Cond Value 3",
        defaultValue: null,
        labelName: "Cond Value 3",
        placeholder: "Cond Value 3",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,28}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "cond_type_4",
        displayName: "Cond Type 4",
        defaultValue: null,
        labelName: "Cond Type 4",
        placeholder: "Cond Type 4",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,28}$/)],
        fieldType : FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        hasDescription:true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "cond_type_4",
            bindValue : "cond_type_4",
            dataFields : []
        }
    },
    {
        fieldName: "cond_value_4",
        displayName: "Cond Value 4",
        defaultValue: null,
        labelName: "Cond Value 4",
        placeholder: "Cond Value 4",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,28}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "goods_receipt_indicator",
        displayName: "Goods Receipt Indicator",
        defaultValue: null,
        labelName: "Goods Receipt Indicator",
        placeholder: "Goods Receipt Indicator",
        validators: [Validators.required],//[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,1}$/)],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "goods_receipt_indicator",
            bindValue : "goods_receipt_indicator",
            dataFields : [{desc:"X-Yes", code:"X"},{desc:"Y-No", code:"-"}]
        },
        hasDescription:true,
        required:true
    },
    {
        fieldName: "delivery_address_title",
        displayName: "Delivery Address Title",
        defaultValue: null,
        labelName: "Delivery Address Title",
        placeholder: "Delivery Address Title",
        validators: null, //[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._,-]{0,4}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "delivery_address_name_1",
        displayName: "Delivery Address Name",
        defaultValue: null,
        labelName: "Delivery Address Name",
        placeholder: "Delivery Address Name",
        validators: null,//[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._,-]{0,40}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
    },
    {
        fieldName: "delivery_address_name_2",
        displayName: "Delivery Address Name 2",
        defaultValue: null,
        labelName: "Delivery Address Name 2",
        placeholder: "Delivery Address Name 2",
        validators: [],//Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._,-]{0,40}$/)
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
    },
    {
        fieldName: "street_or_house_number",
        displayName: "Street/House Number",
        defaultValue: null,
        labelName: "Street/House Number",
        placeholder: "Street/House Number",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required:true,
        
    },
    {
        fieldName: "district",
        displayName: "District",
        defaultValue: null,
        labelName: "District",
        placeholder: "District",
        validators: null,// [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,40}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required:true
    },
    {
        fieldName: "postal_code",
        displayName: "Postal Code",
        defaultValue: null,
        labelName: "Postal Code",
        placeholder: "Postal Code",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,10}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required:true
    },
    {
        fieldName: "city",
        displayName: "City",
        defaultValue: null,
        labelName: "City",
        placeholder: "City",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,40}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required:true,
        
    },
    {
        fieldName: "country",
        displayName: "Country",
        defaultValue: null,
        labelName: "Country",
        placeholder: "Country",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required:true,
        
    },
    {
        fieldName: "region",
        displayName: "Region",
        defaultValue: null,
        labelName: "Region",
        placeholder: "Region",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required:true,
        
    },

   {
        fieldName: "gl_account",
        displayName: "GL Account",
        defaultValue: null,
        labelName: "GL Account",
        placeholder: "GL Account",
        validators: [],//[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,10}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    }, 
    {
        fieldName: "multiple_account",
        displayName: "Multiple Acc",
        defaultValue: null,
        labelName: "Multiple Acc",
        placeholder: "Multiple Acc",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,10}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "wbs_element",
        displayName: "WBS Element",
        defaultValue: null,
        labelName: "WBS Element",
        placeholder: "WBS Element",
        validators: [],//[Validators.required,Validators.pattern(/^[0-9]{0,8}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "asset_no",
        displayName: "Asset. NO",
        defaultValue: null,
        labelName: "Asset. NO",
        placeholder: "Asset. NO",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,10}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "order_no",
        displayName: "Order. NO",
        defaultValue: null,
        labelName: "Order. NO",
        placeholder: "Order. NO",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,12}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "sales_order_number",
        displayName: "Sales Order NO",
        defaultValue: null,
        labelName: "Sales Order NO",
        placeholder: "Sales Order NO",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "sales_order_item",
        displayName: "Sales Item No",
        defaultValue: null,
        labelName: "Sales Item No",
        placeholder: "Sales Item No",
        validators: [Validators.pattern(ONLY_NUMBER_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "service_line_item_no",
        displayName: "Service Line item No",
        defaultValue: null,
        labelName: "Service Line item No",
        placeholder: "Service Line item No",
        validators: [Validators.pattern(ONLY_NUMBER_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "line_item_no",
        displayName: "Line item No",
        defaultValue: null,
        labelName: "Line item No",
        placeholder: "Line item No",
        validators: [Validators.required, Validators.pattern(ONLY_NUMBER_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true
    },
    {
        fieldName: "service_master",
        displayName: "Service code ",
        defaultValue: null,
        labelName: "Service code ",
        placeholder: "Service code ",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "service_quantity",
        displayName: "Service Quantity",
        defaultValue: null,
        labelName: "Service Quantity",
        placeholder: "Service Quantity",
        validators: [Validators.pattern(FLOAT_NUMBER_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
    },
    {
        fieldName: "service_UoM",
        displayName: "Service UoM",
        defaultValue: null,
        labelName: "Service UoM",
        placeholder: "Service UoM",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "gross_price",
        displayName: "Gross Price",
        defaultValue: null,
        labelName: "Gross Price",
        placeholder: "Gross Price",
        validators: [Validators.pattern(FLOAT_NUMBER_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "tax_code",
        displayName: "Tax Code",
        defaultValue: null,
        labelName: "Tax Code",
        placeholder: "Tax Code",
        validators: [Validators.required],
        fieldType: FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "tax_code",
            bindValue : "tax_code",
            dataFields : []
        },
        hasDescription:true,
        required:true
    },
    {
        fieldName: "sac_code_or_tax_tarrif_code",
        displayName: "Tax tariff/SAC/HSN code",
        defaultValue: null,
        labelName: "SAC code/Tax tariff code",
        placeholder: "SAC code/Tax tariff code",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "dist_indicator",
        displayName: "Dist. Indicator (1/2/3)",
        defaultValue: null,
        labelName: "Dist. Indicator (1/2/3)",
        placeholder: "Dist. Indicator (1/2/3)",
        validators: null,
        fieldType: FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "dist_indicator",
            bindValue : "dist_indicator",
            dataFields : [1,2,3]
        },
        disabled:true
    },
    {
        fieldName: "seq_no_of_distribution",
        displayName: "Sq. No of destribution",
        defaultValue: null,
        labelName: "Sq. No of destribution",
        placeholder: "Sq. No of destribution",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        disabled:true
        
    },
    {
        fieldName: "quantity_or_percentage",
        displayName: "Quantity/Percentage",
        defaultValue: null,
        labelName: "Quantity/Percentage",
        placeholder: "Quantity/Percentage",
        validators: [Validators.pattern(FLOAT_NUMBER_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
    },
    {
        fieldName: "net_price",
        displayName: "Net Value",
        defaultValue: 0.00,
        labelName: "Net Value",
        placeholder: "Net Value",
        validators: [Validators.pattern(FLOAT_NUMBER_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "service_net_price",
        displayName: "Service Net Value",
        defaultValue: null,
        labelName: "Service Net Value",
        placeholder: "Service Net Value",
        validators: [Validators.pattern(FLOAT_NUMBER_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "recipient",
        displayName: "Recepient",
        defaultValue: null,
        labelName: "Recepient",
        placeholder: "Recepient",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,12}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "requestor",
        displayName: "Requestor",
        defaultValue: null,
        labelName: "Requestor",
        placeholder: "Requestor",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
        
    },
    {
        fieldName: "order_ack",
        displayName: "Acknowledgement Required",
        defaultValue: null,
        labelName: "Acknowledgement Required",
        placeholder: "Acknowledgement Required",
        validators: [
            Validators.required, 
            (control: AbstractControl) => {
                const value = control.value;
                return (value === 'X' || value === 'Y') ? null : { yesNoInvalid: true };
            }
        ],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "ack_req",
            bindValue : "ack_req",
            dataFields : [{desc:"X-Yes", code:"X"},{desc:"Y-No", code:"Y"}]
        },
        hasDescription:true,
        required:true
    },
    {
        fieldName: "po_number",
        displayName: "PO Number",
        defaultValue: null,
        labelName: "PO Number",
        placeholder: "PO Number",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        disabled:false
    },
    {
        fieldName: "material_po_text",
        displayName: "Material PO Text(Max Char:1500)",
        defaultValue: null,
        labelName: "Material PO Text",
        placeholder: "Material PO Text",
        validators: [Validators.required],//>250
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required:true
    },
    {
        fieldName: "short_text",
        displayName: "Short Text(Max Char:40)",
        defaultValue: null,
        labelName: "Short Text",
        placeholder: "Short Text",
        validators: [Validators.required],
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName: "info_record_po_text",
        displayName: "Info Record PO Text(Max Char:150)",
        defaultValue: null,
        labelName: "Info Record PO Text",
        placeholder: "Info Record PO Text",
        validators: null,
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "item_text",
        displayName: "Item Text(Max char:150)",
        defaultValue: null,
        labelName: "Item Text",
        placeholder: "Item Text",
        validators: null,
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
    },
    {
        fieldName: "info_record_note",
        displayName: "Info Record Note(Max char:150)",
        defaultValue: null,
        labelName: "Info Record Note",
        placeholder: "Info Record Note",
        validators: null,
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName : "schedule_line",
        displayName : "Schedule Line",
        defaultValue : "",
        labelName : "Schedule Line",
        placeholder : "Schedule Line",
        validators: [Validators.required],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        required: true,
        isAutoComplete: false,
        hasDescription:true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "schedule_line",
            bindValue : "schedule_line",
            dataFields : [{desc:"X-Yes", code:"X"},{desc:"Y-No", code:"Y"}]
            }
    },
]

export const PO_HEADER_FORM_FIELDS : Array<IFormField> =   [
    {
        fieldName: "purchasing_organization",
        displayName: "Purchasing Organization",
        defaultValue: null,
        labelName: "Purchasing Organization",
        placeholder: "Purchasing Organization",
        validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{0,4}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
    },
    {
        fieldName: "purchasing_group",
        displayName: "Purchasing Group",
        defaultValue: null,
        labelName: "Purchasing Group",
        placeholder: "Purchasing Group",
        validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        // 
        required: true,
    },
    {
        fieldName: "company_code",
        displayName: "Company Code",
        defaultValue: null,
        labelName: "Company Code",
        placeholder: "Company Code",
        validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9 ]{0,4}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName: "vendor_number",
        displayName: "Vendor Number",
        defaultValue: null,
        labelName: "Vendor Number",
        placeholder: "Vendor Number",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        disabled:true
    },
    {
        fieldName: "incoterms",
        displayName: "Incoterms",
        defaultValue: null,
        labelName: "Incoterms",
        placeholder: "Incoterms",
        validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,3}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        required: true,
        UIVisible: true,
        
    },
    {
        fieldName: "incoterms_description",
        displayName: "Incoterms Description",
        defaultValue: null,
        labelName: "Incoterms Description",
        placeholder: "Incoterms Description",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
        
    },
    {
        fieldName: "payment_terms",
        displayName: "Payment Terms",
        defaultValue: null,
        labelName: "Payment Terms",
        placeholder: "Payment Terms",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName: "currency",
        displayName: "Currency",
        defaultValue: null,
        labelName: "Currency",
        placeholder: "Currency",
        validators: [Validators.required],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName : "GBK",
        displayName : "GBK",
        defaultValue : "",
        labelName : "GBK",
        placeholder : "GBK",
        validators: null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        isAutoComplete: false,
        UIVisible : true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "GBK",
            bindValue : "GBK",
            dataFields : []
        },
    },
    {
        fieldName : "shipping_code",
        displayName : "Shipping Code",
        defaultValue : "",
        labelName : "Shipping Code",
        placeholder : "Shipping Code",
        validators: null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        hasDescription:true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "shipping_code",
            bindValue : "shipping_code",
            dataFields : []
        },
    },
    {
        fieldName: "warranties",
        displayName: "Warranties",
        defaultValue: null,
        labelName: "Warranties",
        placeholder: "Warranties",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true
        
    },
    {
        fieldName: "header_note",
        displayName: "Header Note",
        defaultValue: null,
        labelName: "Header Note",
        placeholder: "Header Note",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "contract_riders",
        displayName: "Contact Riders(Max Char:1000)",
        defaultValue: null,
        labelName: "Contact Riders",
        placeholder: "Contact Riders",
        validators: [Validators.maxLength(1000)],
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "remarks",
        displayName: "Remarks(Max Char:1000)",
        defaultValue: null,
        labelName: "Remarks",
        placeholder: "Remarks",
        validators: [Validators.maxLength(1000)],
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "header_text",
        displayName: "Header Text(Max Char:1000)",
        defaultValue: null,
        labelName: "Header Text",
        placeholder: "Header Text",
        validators: [Validators.required, Validators.maxLength(1000)],//Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,4}$/)
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required:true
    },
    {
        fieldName: "F02_text",
        displayName: "F02 TEXT(Max Char:1000)",
        defaultValue: null,
        labelName: "F02 TEXT",
        placeholder: "F02 TEXT",
        validators: [Validators.maxLength(1000)],
        fieldType: FieldEnum.TEXTAREA,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "sales_person",
        displayName: "Salesperson",
        defaultValue: null,
        labelName: "Salesperson",
        placeholder: "Salesperson",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
        
    },
    {
        fieldName: "your_reference",
        displayName: "Your Reference",
        defaultValue: null,
        labelName: "Your Reference",
        placeholder: "Your Reference",
        validators: [Validators.required, Validators.maxLength(43), Validators.pattern(/^[a-zA-Z0-9-]+$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "our_reference",
        displayName: "Our Reference",
        defaultValue: null,
        labelName: "Our Reference",
        placeholder: "Our Reference",
        validators: [Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,12}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName : "partner_code",
        displayName : "Partner Code",
        defaultValue : "",
        labelName : "Partner Code",
        placeholder : "Partner Code",
        validators: null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        isAutoComplete: false,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "partner_code",
            bindValue : "partner_code",
            dataFields : []
        },
    },
    {
        fieldName: "emp_code",
        displayName: "Emp Code",
        defaultValue: null,
        labelName: "Emp Code",
        placeholder: "Emp Code",
        validators: [Validators.pattern(ONLY_NUMBER_PATTERN)],// 8 digit
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "quotation",
        displayName: "Quotation",
        defaultValue: null,
        labelName: "Quotation",
        placeholder: "Quotation",
        validators: [],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        
        required:true
    },
    {
        fieldName: "quotation_date",
        displayName: "Quotation Date",
        defaultValue: null,
        labelName: "Quotation Date",
        placeholder: "yyyy-MM-DD",
        validators: null,
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "awv_code_1",
        displayName: "AWV Code 1",
        defaultValue: null,
        labelName: "AWV Code 1",
        placeholder: "AWV Code 1",
        validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,1}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName: "awv_code_2",
        displayName: "AWV Code 2",
        defaultValue: null,
        labelName: "AWV Code 2",
        placeholder: "AWV Code 2",
        validators: [Validators.required, Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,1}$/)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        required: true,
        
    },
    {
        fieldName: "enduser_for_FTrade",
        displayName: "Enduser for F.Trade",
        defaultValue: null,
        labelName: "Enduser for F.Trade",
        placeholder: "Enduser for F.Trade",
        // validators: [Validators.required],
        validators:[],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
        // required: true,
    },
    {
        fieldName: "complete_delivery_check_mark",
        displayName: "Complete Delivery Check Mark",
        defaultValue: null,
        labelName: "Complete Delivery Check Mark",
        placeholder: "Complete Delivery Check Mark",
        validators: [],//[Validators.pattern(/^[a-zA-Z0-9!@#\$%\^\&*\ )\(+=._-]{0,1}$/)],
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        isAutoComplete: false,
        size : "col-md-3",
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "complete_delivery_check_mark",
            bindValue : "complete_delivery_check_mark",
            dataFields : [{desc:"X - complete delivery", code:"X"}, {desc:"Y- partial delivery",code:""}]
        },
        UIVisible: true,
        hasDescription: true
    },
    {
        fieldName : "clause",
        displayName : "clause",
        defaultValue : "",
        labelName : "clause",
        placeholder : "clause",
        validators: null,
        fieldType : FieldEnum.SELECT,
        fieldSubType : SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        isAutoComplete: false,
        hasDescription:true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "clause",
            bindValue : "clause",
            dataFields : []
        },
    },
    {
        fieldName: "vendor_email_1",
        displayName: "Vendor Email 1",
        defaultValue: null,
        labelName: "Vendor Email 1",
        placeholder: "Vendor Email 1",
        validators: [Validators.pattern(EMAIL_PATTERN)],
        fieldType: FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        required: true,
        isAutoComplete: true,
        hasDescription:true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "clause",
            bindValue : "clause",
            dataFields : []
        },
    },
    {
        fieldName: "vendor_email_2",
        displayName: "Vendor Email 2",
        defaultValue: null,
        labelName: "Vendor Email 2",
        placeholder: "Vendor Email 2",
        validators: [Validators.pattern(EMAIL_PATTERN)],
        fieldType: FieldEnum.SELECT,
        fieldSubType: SubFieldEnum.TEXT,
        size : "col-md-3",
        UIVisible : true,
        hasDescription:true,
        isAutoComplete: true,
        selectFields : {
            apiAsync$ : of(),
            bindLabel : "clause",
            bindValue : "clause",
            dataFields : []
        },
    },
    {
        fieldName: "req_email_1",
        displayName: "Req Email 1",
        defaultValue: null,
        labelName: "Req Email 1",
        placeholder: "Req Email 1",
        validators: [Validators.pattern(EMAIL_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
    {
        fieldName: "req_email_2",
        displayName: "Req Email 2",
        defaultValue: null,
        labelName: "Req Email 2",
        placeholder: "Req Email 2",
        validators: [Validators.pattern(EMAIL_PATTERN)],
        fieldType: FieldEnum.INPUT,
        fieldSubType: SubFieldEnum.TEXT,
        size: "col-md-3",
        UIVisible: true,
    },
]